const inrFormatter = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  maximumFractionDigits: 0,
});

export function formatInr(amount) {
  const numericAmount = Number(amount) || 0;
  return inrFormatter.format(numericAmount);
}
